document.addEventListener('DOMContentLoaded', function () {
  function waitForjQuery(callback) {
    if (typeof jQuery !== 'undefined') {
      console.log('✅ jQuery is loaded');
      callback(jQuery);
    } else {
      console.log('⏳ Waiting for jQuery...');
      setTimeout(function () {
        waitForjQuery(callback);
      }, 100);
    }
  }

  waitForjQuery(function ($) {
    console.log('⚙️ jQuery is ready. Waiting for Yotpo link...');

    function updateYotpoLink() {
      const $link = $('.yotpo-bottomline a');
      if ($link.length) {
        console.log('🎯 Found Yotpo link. Updating...');
        $link.attr('href', '#yotpo-app');

        $link.on('click', function (e) {
          e.preventDefault();
          const el = document.getElementById('yotpo-app');
          if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
          }
        });
        return true;
      }
      return false;
    }

    const yotpoInterval = setInterval(function () {
      const found = updateYotpoLink();
      if (found) {
        clearInterval(yotpoInterval);
      }
    }, 300);
  });
});